
function actionOnEnter(e,country) {
	var numberPlate = document.getElementById('plate_number').value;
	var key = e.keyCode || e.which;
	if (key == 13 && numberPlate) {
		searchDriveRightVehicle(country)
	}
};
function searchDriveRightVehicle(country){
    $("#driveright-default-error-anchor").hide();
    const $searchButton = $("#searchbutton").prop('disabled', true);
    $("#searchbutton").hide();

	var numberPlate = document.getElementById('plate_number').value;
	var carId;
    var csrfToken = $("input[name='_csrf']").val();
    var payload = {}
    payload['platenumber'] = numberPlate;
    payload['country'] = country;

    $.ajax({
			type : "POST",
            url: "/ws/driveright/vehicle",
            data: JSON.stringify(payload),
            contentType: "application/json; charset=utf-8",
            headers: { "X-CSRF-TOKEN": csrfToken },
			success : function(data) {
				if (!data || !data.carID) {
					$("#driveright-default-error-anchor").show();
					$("#driveRight_sizeDiv").hide()
				} else {
					carId = data.carID;
                    if(vehicleInfoSearchScope && vehicleInfoSearchScope=="tyres"){

                        $.ajax({
                            url: contextPath + "/delticom/brand/proxy/?rsmKBA=" + carId
                        }).done(function(result) {

                            var data = JSON.parse(result);
                            if (isFromAdvice){
                                renderDriveRightResultsTable(data);
                            } else {
                                $("#driveRight_sizeDiv").show();
                                $("#driveright-default-error-anchor").hide();
                                var dropdown = $("#driveRight-carselector-tyre-size");
                                $(dropdown).find('option:not([value=""])').remove();
                                $.each(data, function(index, typedetails) {
                                    if(data.selectedKey!=typedetails.v){
                                        $(dropdown).append( "<option value='" + typedetails.v + "'>" + typedetails.d +"</option>" );
                                    }else{
                                        $(dropdown).append( "<option selected value='" +typedetails.v + "'>"  +typedetails.d+"</option>" );
                                    }
                                });
                                if (data.length == 1) {
                                    // select first element
                                    $(dropdown).val(data[0].v);
                                    $("#carselector-default-submit").show();
                                    $("#tyreDimensionsSubmitButton").prop('disabled', false);
                                    populateVehicleInfoSearchForm($("#driveRight-carselector-tyre-size").val());
                                    $("#submitButtonDiv").show();
                                } else if (data.length == 0) {
                                    $("#driveright-default-error-anchor").show();
                                }
                            }
                        });
                    } else{
                        window.location.href = contextPath + vehicleUrl + carId;
                    }
				}
			},
			error : function(xhr, ajaxOptions, thrownError) {
				$("#driveright-default-error-anchor").show();
				$("#driveRight_sizeDiv").hide()
			},
            complete : function () {
                $searchButton.prop('disabled', false);
            }
    });
};
function checkInputHsnData(){
    checkInputData();
    var hsn = document.getElementById("HSN").value;
    if (hsn.length == 4)
    {
        $(document.getElementById("TSN")).trigger("focus");
    }
}
$(".hsnInput").on('keyup', function (e) {
    checkInputHsnData();
    $("#carselector-drive-right-error-anchor").hide();
    $("#driveRight_sizeDiv").hide();
    $("#submitButtonDiv").hide();

});
$(".tsnInput").on('keyup', function (e) {
    checkInputTsnData();
    $("#carselector-drive-right-error-anchor").hide();
    $("#driveRight_sizeDiv").hide();
    $("#submitButtonDiv").hide();
    if (e.keyCode == 13) {
          searchDETyres();
    }
});

$("#hsn-tsn-button").on('click', function () {
    searchDETyres();
});

function checkInputTsnData(){
    checkInputData();
}
function checkInputData(){
		var hsn = document.getElementById("HSN").value;
		var tsn = document.getElementById("TSN").value;
        $("#hsn-tsn-button").show();
        if(hsn.length != 4 || tsn.length < 6 || tsn.length > 9){
			 $("#suchebutton").prop('disabled', true).trigger("focus");
		}else{
			$("#suchebutton").prop('disabled', false);
		}
	};
function searchDE() {
	var hsn = document.getElementById("HSN").value;
	var carId;
	var tsn = document.getElementById("TSN").value;
	if (hsn && tsn) {
		$.ajax({
			type : 'GET',
			url : contextPath + "/ws/jfnetwork/de/vehicle/?tsn=" + tsn
					+ "&hsn=" + hsn,
			success : function(data) {

				if (!data) {
					var errorDiv = document.getElementById("carselector-drive-right-error-anchor");
					errorDiv.style.display = "block";
                } else {
                    showLoadingSpinner();
					carId = data.id;
                    if(String(resultUrlSelector).includes("/cw/vehicle")) {
                        window.location.href = contextPath + "/cw/rim-selector?vehicle_ids=" + carId;
                    }
                    else if(String(resultUrlSelector).includes("/rims/vehicle")) {
                        window.location.href = contextPath + "/rims/rim-selector?vehicle_ids=" + carId;
                    }
                    else {
                        window.location.href = contextPath + "/cw/rim-selector?vehicle_ids=" + carId;
                    }

                }
			},
			error : function(xhr, ajaxOptions, thrownError) {
				alert(thrownError);
			}
		});
	}
};
function searchDETyres() {
	var hsn = document.getElementById("HSN").value;
	var carId;
	var tsn = document.getElementById("TSN").value;
	if (hsn && tsn) {
		$.ajax({
			type : 'GET',
			url : contextPath + "/ws/jfnetwork/de/vehicle/?tsn=" + tsn
					+ "&hsn=" + hsn,
			success : function(data) {
				if (!data) {
					var errorDiv = document.getElementById("carselector-drive-right-error-anchor");
					errorDiv.style.display = "block";
					} else {
                    $("#hsn-tsn-button").hide();
					carId = data.id;
					if (document.getElementById("advice_title_car_manufacturer")){
                       document.getElementById("advice_title_car_manufacturer").innerHTML =" "+data.manufacturer;
                       document.getElementById("advice_title_car_class").innerHTML =" "+ data.class;
                       document.getElementById("advice_title_car_version").innerHTML =" "+ data.version;
                       document.getElementById("advice_title_car_finish").innerHTML =" "+ data.baujahr + " "+data.ps+" PS /  "+data.kw+" KW "+typeTranslation +" " + data.type + " " + data.cocMinSize+" "+inchTranslation;
                    }

                    $.ajax({
                        url: contextPath + "/delticom/brand/proxy"+"?rsmKBA=" + carId
                    }).done(function(result) {

                        var data = JSON.parse(result);
                        if (isFromAdvice){
                            renderDriveRightResultsTable(data);
                        } else {
                            $("#driveRight_sizeDiv").show();
                            var dropdown = $("#driveRight-carselector-tyre-size");
                            $(dropdown).find('option:not([value=""])').remove();
                            $.each(data, function(index, typedetails) {
                                if(data.selectedKey!=typedetails.v){
                                    $(dropdown).append( "<option value='" + typedetails.v + "'>" + typedetails.d +"</option>" );
                                }else{
                                    $(dropdown).append( "<option selected value='" +typedetails.v + "'>"  +typedetails.d+"</option>" );
                                }
                            });
                            if (data.length == 1) {
                                // select first element
                                $(dropdown).val(data[0].v);
                                $("#carselector-default-submit").show();
                            } else if (data.length == 0) {
                                $("#carselector-default-error-anchor").after(
                                    '<div data-alert class="alert-box alert" id="carselector-default-error">' + l("carselector_default_vehicle_not_found") + '<a href="#" class="close">&times;</a>' + '</div>').parent().foundation();
                            }
                        }
                    });
				}
			},
			error : function(xhr, ajaxOptions, thrownError) {
				alert(thrownError);
			}
		});
	}
};
var renderDriveRightResultsTable = function(data) {
    $(".j-results-table").empty();
    var tableContent = "";
    var tableRowTemplate = "<div class='tire-row'>" +
		"<div class='column-tire-sizes'>@tireName@</div>" +
		"<div class='column-link-images'>@linkImages@</div>" +
		"<div class='column-search-link'>@searchLink@</div>" +
        "</div>";
    var speedIndexTemplate = "<span>" + ACC.adviceSpeedIndex + "</span>" +
        "<span class='font-bold margin-left5'>@speedIndexValue@</span>";
    var searchLinkTemplate = "<a class='pure-button pure-button-primary btn-wrapper' href='@searchUrl@'><span class=\"btn-text\">" + ACC.adviceSearchLink + "</span></a>";
    var searchUrlTemplate = "" + ACC.config.contextPath +
        "/search?" +
        "vehicleTypes=PKW&" +
        "season=@sowigan@&" +
        "width=@width@&" +
        "profile=@profile@&" +
        "size=@size@&" +
        "speedRating=@speedRating@";

    var searchImagesTemplate = "<a href='@allSeasonUrl@'>@allSeasonImage@  " + ACC.seasonGan + "</a>" +
        "<a href='@summerUrl@'>@summerImage@  " + ACC.seasonSo + "</a>" +
        "<a href='@winterUrl@'>@winterImage@  " + ACC.seasonWi + "</a>";

    var tireSummerImg = "<img class='tyre-season-image-details' alt='so' src='https://static.delti.com/static/common_files/images/So.gif?v=1'>";
    var tireWinterImg = "<img class='tyre-season-image-details' alt='wi' src='https://static.delti.com/static/common_files/images/Wi.gif?v=1'>";
    var tireAllSeasonImg = "<img class='tyre-season-image-details' alt='gan' src='https://static.delti.com/static/common_files/images/GAN.gif?v=1'>";

    $(data).each(function() {
        var tireName = this.d;
        var values = this.v.split("|");
        var speedIndex = values[values.length - 2];
        var speedIndexValue = speedIndexTemplate.replace(/@speedIndexValue@/g, speedIndex);

        var searchUrlValue = searchUrlTemplate.replace(/@width@/g, values[0]).replace(/@profile@/g, values[1]).replace(/@size@/g, values[3]).replace(/@speedRating@/g, getSpeedRating(values[4])).replace(/@sowigan@/g, "");
        var searchLinkValue = searchLinkTemplate.replace(/@searchUrl@/g, searchUrlValue);
        var tireLink = "<b><a href='" + searchUrlValue + "'>" + tireName + "</a></b>";

        var searchSummerUrl = searchUrlTemplate.replace(/@width@/g, values[0]).replace(/@profile@/g, values[1]).replace(/@size@/g, values[3]).replace(/@speedRating@/g, getSpeedRating(values[4])).replace(/@sowigan@/g, "SO");
        var searchWinterUrl = searchUrlTemplate.replace(/@width@/g, values[0]).replace(/@profile@/g, values[1]).replace(/@size@/g, values[3]).replace(/@speedRating@/g, getSpeedRating(values[4])).replace(/@sowigan@/g, "WI");
        var searchAllSeasonUrl = searchUrlTemplate.replace(/@width@/g, values[0]).replace(/@profile@/g, values[1]).replace(/@size@/g, values[3]).replace(/@speedRating@/g, getSpeedRating(values[4])).replace(/@sowigan@/g, "GAN");
        var searchImagesValue = searchImagesTemplate.replace(/@allSeasonUrl@/g, searchAllSeasonUrl).replace(/@allSeasonImage@/g, tireAllSeasonImg).replace(/@summerUrl@/g, searchSummerUrl).replace(/@summerImage@/g, tireSummerImg).replace(/@winterUrl@/g, searchWinterUrl).replace(/@winterImage@/g, tireWinterImg);

        tableContent += tableRowTemplate.replace(/@tireName@/g, tireLink).replace(/@speedIndex@/g, speedIndexValue).replace(/@searchLink@/g, searchLinkValue).replace(/@linkImages@/g, searchImagesValue);
    });
    $(".j-results-table").append(tableContent);
    $(".j-results-section").show();
};


function getSpeedRating(data) {
    return data;
};
$(document).ready(function() {
    $("#driveRight-carselector-tyre-size").on('change', function() {
            preselect = false;
            if (this.value != '') {
                populateForm($("#driveRight-carselector-tyre-size").val());
                $("#submitButtonDiv").show();

            }
    });
});
var populateForm = function(data) {
    var values = data.split("|"); // split by pipe creates individual values
    var formValues = {
        width: values[0],
        profile: values[1],
        constructionType: values[2],
        size: values[3],
        loadIndex: values[4],
        speedRating: (values[5]==="Y") ? "ZR,W,Y" : values[5]
	};
    if (values[5]) {
        formValues['sowigan'] = values[5].toLowerCase()
	};
    for (var key in formValues) {

        $("#searchByBrandForm input[name='" + key +"']").val(formValues[key]);
    }
};